/**
 * simSourceProfile.js
 *
 * Per-source behavior profile for the simulation form. Each MapCase source tier
 * opts into a specific set of behaviors (default sim-spec, server-setup reuse,
 * minimize box). Kept as small pure predicates so the matrix is testable in
 * isolation and every consumer routes through one accessor -- not a scatter of
 * ad-hoc `sourceDesc === X` guards (the #981 incomplete-refactor lesson).
 */
import { MapCase } from '../../../model/MapCase';

// Sources whose structures ship a prepared, server-resident fragment setup: they
// get a default sim-spec, and unloaded members (e.g. curated-panel structures) can
// be reused without a "Prepare System" pass. Managed = the company-managed curated
// datasets (the kinase library); routed like Public/cp server-side
// (see CP_SOURCE_DESCS in services/services/shopping/views.py).
export const isPreparedSetupSource = (sourceDesc) => [
    MapCase.Sources.Public,
    MapCase.Sources.Fragserv,
    MapCase.Sources.Managed,
].includes(sourceDesc);

// The minimize-box default for a structure: its own prep metadata when present
// (the value it was originally prepared/run with), else the per-source default.
// Only Public structures minimize by default; Managed/curated structures do not
// (and, until their simulation-meta.json is backfilled, fall through to this
// source default). An explicit metadata value -- true OR false -- always wins.
export function defaultMinimizeBox(existingSimMeta, sourceDesc) {
    return existingSimMeta?.minimizeBox ?? sourceDesc === MapCase.Sources.Public;
}
